import { isString, isObject } from 'lodash';

const HTTP_CODE_MESSAGE_DEFAULT = {
  400: 'Bad request. Check if all fields are fulfilled correctly.',
  401: "Unauthorized. You don't have permission.",
  422: 'Bad request. Check if all fields are fulfilled correctly.',
  500: 'Server error. Try again in a few minutes.',
};

const hasErrorDetail = (errorDetail) => !!errorDetail;

const transformErrorDetail = (errorDetail) => {
  if (isObject(errorDetail)) {
    const message = Reflect.has(errorDetail, 'message') ? String(errorDetail.message) : undefined;
    if (!message) {
      return undefined;
    }
    const path = Reflect.has(errorDetail, 'path')
      ? String(errorDetail.path).replace('/', '')
      : undefined;
    return `${path ? `${path} - ` : ''}${message}`;
  } else if (isString(errorDetail)) {
    return errorDetail;
  }
  return undefined;
};

const getMessages = (errorMessage) => {
  if (errorMessage === undefined) {
    return undefined;
  } else if (Array.isArray(errorMessage)) {
    return errorMessage.join('. ');
  } else if (isString(errorMessage)) {
    return errorMessage;
  } else if (errorMessage?.message && isString(errorMessage?.message)) {
    return errorMessage?.message;
  }
  return 'Unreachable error message. Please try again later.';
};

const getDetails = (errorDetails) => {
  if (Array.isArray(errorDetails)) {
    return errorDetails.map(transformErrorDetail).filter(hasErrorDetail).join('. ');
  } else if (isString(errorDetails)) {
    return errorDetails;
  }
  return undefined;
};

const normalizerError = (error) => {
  const defaultErrorMessage = HTTP_CODE_MESSAGE_DEFAULT[error?.statusCode ?? 500];
  const message = getMessages(error?.message);
  const details = getDetails(error?.details);

  return {
    message: details ? message ?? defaultErrorMessage : 'Error',
    details: details ?? message ?? defaultErrorMessage,
    statusCode: error?.statusCode,
  };
};

export default normalizerError;
